import React from "react";
import queryString from "query-string";
import moment from "moment";
import { Redirect } from "react-router-dom";
// COMPONENTS
import Row from "components/common/Row";
import Col from "components/common/Col";
import Loading from "components/common/Loading";
import Breadcrumb from "components/common/Breadcrumb";
import MonthComponent from "components/common/MonthComponent";
import HealthAndWelfare from "./HealthAndWelfare";
import Eligibility from "./Eligibility";
import Retirement from "./Retirement";
import Benefits from "./Benefits";
import Downloads from "./Downloads";
import SideNav from "components/common/SideNav";
// APOLLO
import { Query } from "react-apollo";
import customerReport from "ApolloClient/Queries/customerReport";
// LIB
import helpers from "lib/helpers/GeneralHelpers";

class AppReports extends React.PureComponent {
  state = {};
  onParamChange = (newValues) => {
    let oldParams = queryString.parse(this.props.location.search);
    let newParams = {
      ...oldParams,
      ...newValues,
    };
    let newString = queryString.stringify(newParams);
    this.props.history.push(`?${newString}`);
  };
  checkParams = () => {
    let oldParams = queryString.parse(this.props.location.search);
    if (!oldParams.tab && oldParams.tab !== "null") {
      let month = moment().subtract(1, "months").format("MMMM").toLowerCase();
      let year = moment().format("YYYY").toLowerCase();
      return this.onParamChange({ month, year, tab: "health" });
    }
    if (
      (!oldParams.year && oldParams.year !== "null") ||
      (!oldParams.month && oldParams.month !== "null")
    ) {
      let month = moment().subtract(1, "months").format("MMMM").toLowerCase();
      let year = moment().format("YYYY").toLowerCase();
      return this.onParamChange({ month, year });
    }
  };
  componentWillMount() {
    this.checkParams();
  }
  getTab = (tab) => {
    switch (tab) {
      case "health":
        return "Health & Welfare";
      case "eligibility":
        return "Eligibility";
      case "benefits":
        return "Benefits";
      case "retirement":
        return "Retirement";
      case "download":
        return "Download XL";
      default:
        return null;
    }
  };
  getNavItems = () => {
    // an array of data that will build our sidenav items
    let navItems = [
      {
        label: "Health & Welfare",
        activeValue: "health",
        onClick: () =>
          this.onParamChange({
            tab: "health",
          }),
      },
      {
        label: "Eligibility",
        activeValue: "eligibility",
        onClick: () =>
          this.onParamChange({
            tab: "eligibility",
          }),
      },
      {
        label: "Benefits",
        activeValue: "benefits",
        onClick: () =>
          this.onParamChange({
            tab: "benefits",
          }),
      },
      {
        label: "Retirement",
        activeValue: "retirement",
        onClick: () =>
          this.onParamChange({
            tab: "retirement",
          }),
      },
      {
        label: "Downloads",
        activeValue: "download",
        onClick: () =>
          this.onParamChange({
            tab: "download",
          }),
      },
    ];

    // if the query does not have retirement data, then we don't want to show the retirement tab
    if (
      this.state.queryData &&
      this.state.queryData.customerReport &&
      !this.state.queryData.customerReport.labelForTotalRetirement &&
      !this.state.queryData.customerReport.totalRetirement
    ) {
      navItems = navItems.filter((item) => item.activeValue !== "retirement");
    }

    // return the nav options
    return navItems;
  };
  render() {
    const { location, history } = this.props;

    // if the user is not a company admin and is just a coEmployee, then redirect them to the dashboard
    if (
      !this.props.currentUser.roles.includes("coAdmin") &&
      this.props.currentUser.roles.includes("coEmployee")
    ) {
      return <Redirect to='/dashboard' />;
    }

    // If user is a company admin but does not have persmission to view company data, we will re-route them
    if (
      this.props.currentUser.roles.includes("coAdmin") &&
      !this.props.currentUser.permissions.includes("viewCompanyData")
    ) {
      return <Redirect to='/account?tab=profile' />;
    }

    const { tab, month, year } = queryString.parse(location.search);

    return (
      <div style={{ padding: 8 }}>
        <Breadcrumb crumbs={["Reports", this.getTab(tab)]} />
        <Row>
          <Col xs={24} md={16} />
          <Col xs={24}>
            {" "}
            <MonthComponent
              year={year}
              month={month}
              onChange={this.onParamChange}
            />
          </Col>
          <Col xs={24} md={6}>
            <SideNav items={this.getNavItems()} tab={tab} />
          </Col>

          <Col xs={24} md={18}>
            {/* Only show this if we have a customerId, year and month */}
            {this.props.currentUser.customerId && year && month && (
              <Query
                query={customerReport}
                fetchPolicy='cache-and-network'
                variables={{
                  customerId: this.props.currentUser.customerId,
                  month: moment(helpers.capitalize(month), "MMMM").format("M"),
                  year: year,
                }}
                onCompleted={(queryData) => this.setState({ queryData })} // story the query result so that we can check it in getNavItems
              >
                {({ loading, data, error }) => {
                  // display spinner if loading
                  if (loading) return <Loading />;
                  // display error if error comes back
                  if (error) {
                    return "Error... please contact support if this issue persists";
                  }
                  // display no result if no results come back
                  if (!data.customerReport) {
                    return "No results for this time period...";
                  }

                  const sharedProps = {
                    history,
                    location,
                    report: data.customerReport,
                  };
                  return (
                    <div>
                      {(() => {
                        switch (tab) {
                          case "retirement":
                            return <Retirement {...sharedProps} />;
                          case "benefits":
                            return <Benefits {...sharedProps} />;
                          case "download":
                            return <Downloads {...sharedProps} />;
                          case "eligibility":
                            return <Eligibility {...sharedProps} />;
                          case "health":
                            return <HealthAndWelfare {...sharedProps} />;
                          default:
                            return <HealthAndWelfare {...sharedProps} />;
                        }
                      })()}
                    </div>
                  );
                }}
              </Query>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

export default AppReports;
